export const mockJobs = [
  {
    id: '1',
    title: 'Senior Frontend Developer',
    company: 'TechCorp',
    location: 'San Francisco, CA',
    type: 'Full-time',
    salary: '$120k - $160k',
    postedAt: '2 days ago',
    logo: 'https://images.unsplash.com/photo-1549924231-f129b911e442?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80',
    description: 'We are seeking an experienced Senior Frontend Developer to join our dynamic team. In this role, you will be responsible for building and maintaining high-quality web applications using modern frontend technologies.',
    technicalSkills: ['React', 'TypeScript', 'GraphQL', 'Next.js', 'Tailwind CSS'],
    softSkills: ['Leadership', 'Communication', 'Mentoring', 'Problem Solving'],
    requirements: [
      '5+ years of experience with React and TypeScript',
      'Experience with GraphQL and modern frontend architecture',
      'Strong understanding of web performance optimization',
      'Experience with responsive design and cross-browser compatibility'
    ],
    responsibilities: [
      'Lead frontend development initiatives and mentor junior developers',
      'Architect and implement scalable frontend solutions',
      'Collaborate with designers and backend developers',
      'Participate in code reviews and technical discussions'
    ],
    benefits: [
      'Competitive salary and equity package',
      'Flexible remote work options',
      'Health, dental, and vision insurance',
      'Professional development budget'
    ]
  },
  // ... other jobs remain the same
];